module.exports = "external-link-arrow"